import React, { useState } from "react";
import "./Vision.css";
import { CaretDownOutlined } from "@ant-design/icons";
import educationImg from "../../Assets/education.png";
import employmentImg from "../../Assets/employment.png";
import engagementImg from "../../Assets/engagment.png";
import showcaseImg1 from "../../Assets/showcase-1.jpeg";
import showcaseImg2 from "../../Assets/showcase-2.jpg";
import showcaseImg3 from "../../Assets/showcase-3.jpg";
import showcaseImg4 from "../../Assets/showcase-4.jpeg";
import showcaseImg5 from "../../Assets/showcase-5.jpeg";
import showcaseImg6 from "../../Assets/sliderImg1.jpg";

const Vision = () => {
  const [stepper, setStepper] = useState(0);

  return (
    <>
      <div className="vision-main-container">
        <h2>Our Vision</h2>
        <div className="vision-container">
          <div
            className="vision-box"
            onClick={() => setStepper(0)}
            typeof="button"
          >
            <img src={educationImg} alt="education Logo" />
            <div className="vision-text">
              <h1>Education</h1>
              <p>
                Promoting Technical Skills Training along with formal Education.
              </p>
            </div>
            {stepper === 0 ? <CaretDownOutlined /> : null}
          </div>
          <div
            className="vision-box"
            onClick={() => setStepper(1)}
            typeof="button"
          >
            <img src={employmentImg} alt="employ Logo" />
            <div className="vision-text">
              <h1>Employment</h1>
              <p>
                Enhancing the number of Job opportunities for Young Population.
              </p>
            </div>
            {stepper === 1 ? <CaretDownOutlined /> : null}
          </div>
          <div
            className="vision-box"
            onClick={() => setStepper(2)}
            typeof="button"
          >
            <img src={engagementImg} alt="engagement Logo" />
            <div className="vision-text">
              <h1>Engagement</h1>
              <p>
              Engaging Youth in Productive Activities for their Character Building.
              </p>
            </div>
            {stepper === 2 ? <CaretDownOutlined /> : null}
          </div>
        </div>
        {stepper === 0 ? (
          <div className="vision-showcase">
            <div className="showcase-card">
              <div className="showcase-box">
                <img src={showcaseImg1} alt="showCase image 1" />
                <div className="showcase-text">
                  <h2>Digital Youth Development Centres</h2>
                  <button>Read More</button>
                </div>
              </div>
              <div className="showcase-box">
                <img src={showcaseImg2} alt="showCase image 2" />
                <div className="showcase-text">
                  <h2>Skills Development Programme</h2>
                  <button>Read More</button>
                </div>
              </div>
              <div className="showcase-box">
                <img src={showcaseImg3} alt="showCase image 3" />
                <div className="showcase-text">
                  <h2>Prime Minister's Laptop Scheme</h2>
                  <button>Coming Soon</button>
                </div>
              </div>
            </div>
          </div>
        ) : stepper === 1 ? (
          <div className="vision-showcase">
            <div className="showcase-card">
              <div className="showcase-box">
                <img src={showcaseImg3} alt="showCase image 3" />
                <div className="showcase-text">
                  <h2>Prime Minister's Youth Business Loan</h2>
                  <button>Read More</button>
                </div>
              </div>
              <div className="showcase-box">
                <img src={showcaseImg4} alt="showCase image 4" />
                <div className="showcase-text">
                  <h2>National Innovation Award</h2>
                  <button>Read More</button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="vision-showcase">
            <div className="showcase-card">
              <div className="showcase-box">
                <img src={showcaseImg5} alt="showCase image 5" />
                <div className="showcase-text">
                  <h2>Talent Hunt Sports League</h2>
                  <button>Read More</button>
                </div>
              </div>
              <div className="showcase-box">
                <img src={showcaseImg6} alt="showCase image 6" />
                <div className="showcase-text">
                  <h2>Green Youth Movement</h2>
                  <button>Read More</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Vision;
